import { SuccessResponseList } from './common'
import { ResponseReportingEvent } from './reportingEvent'
import { User } from './user'

export enum ProjectStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}

export enum ProjectType {
  ASCEND_SPARK = 'ascend_spark',
  STANDALONE = 'standalone',
}

export type ProjectStatusType =
  (typeof ProjectStatus)[keyof typeof ProjectStatus]

export interface ResponseProject {
  can_delete: boolean
  company_id: string
  company_name: string
  created_at: string | null
  created_by: string | null
  created_by_user?: User | null
  deleted_at: string | null
  deleted_by: string | null
  deleted_by_user?: User | null
  id: string
  project_name: string
  project_type: ProjectType
  reporting_events: ResponseReportingEvent[]
  status: ProjectStatus
  total_draft?: number
  total_open_comments_count?: number
  updated_at: string | null
  updated_by: string | null
  updated_by_user?: User | null
}

export interface SuccessResponseListResponseProject extends SuccessResponseList<ResponseProject> {}
